import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/main.scss';
import App from './App';
import storeInit from './redux/store';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux'
import LangLoader from './screens/LangLoader';
import * as Sentry from "@sentry/react";

import 'moment/locale/cs';
import 'moment/locale/sk';

const isUnauthorizedError = (event, hint) => {
  const originalException = hint && hint.originalException;
  const responseStatus = originalException && originalException.response && originalException.response.status;
  const status = responseStatus || (originalException && originalException.status);
  const eventStatus = event && event.contexts && event.contexts.response && event.contexts.response.status_code;
  const exceptionValue = event && event.exception && event.exception.values && event.exception.values[0] && event.exception.values[0].value;

  return status === 401 || eventStatus === 401 || exceptionValue === 'Request failed with status code 401';
}

Sentry.init({
  dsn: "https://3a628b43e9ee48e78b71f6e9752be3a9@o483336.ingest.us.sentry.io/5549550",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration()
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.2,  
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  beforeSend(event, hint) {
    if (isUnauthorizedError(event, hint)) {
      return null;
    }

    return event;
  }
});

const store = storeInit()

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LangLoader store={store}>
        <App />
      </LangLoader>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
